import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import {MdOutlineEmail} from "react-icons/md";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Designed and Developed by Mohamed Saeed</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year} MS</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/EngMohamedSaeed2001"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/mohamed-saeed-8189611ba/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>

            <li className="social-icons">
              <a
                href="https://mail.google.com/mail/u/0/#inbox?compose=CllgCKCBjvBMTHZfzMVNrlSCzcFvjQndvkkjwLlwZKQbfsntfjmGzftLtdvPcZwkmdvHBVLZRgq"
                style={{ color: "white" }}
                target="_blank"
                rel="noopener noreferrer"
              >
              <MdOutlineEmail/>
              </a>

            </li>

          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
